// Generated by scripts/build-ui-icons.mjs.
export { Globe as default } from "../ui/glyphs-4";
